module.exports = __webpack_public_path__ + "static/media/astronautBody.6398c9fb.png";